const STORAGE_KEY = window.__COOKIE_CONSENT_STORAGE_KEY__ || 'cookie_consent_v1';
const OVERLAY_IDS = ['cookie-consent', 'politica-cookies'];

export function ensureCookieOverlaysOnBody() {
  const body = document.body;
  if (!body) return;

  const pinWrapper = document.getElementById('horizontal-scroll-pin-wrapper');
  OVERLAY_IDS.forEach((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (pinWrapper && pinWrapper.contains(el)) {
      body.appendChild(el);
    }
  });
}

export function getCookieConsent() {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return v === 'accepted' || v === 'rejected' ? v : null;
  } catch {
    return null;
  }
}

export function setCookieConsent(value) {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // ignore
  }
}

export function shouldEnableAnalytics() {
  return getCookieConsent() === 'accepted';
}

export function initCookieConsentBanner() {
  const banner = document.getElementById('cookie-consent');
  if (!banner) return;

  ensureCookieOverlaysOnBody();

  // Guard: if the pin wrapper is created later and swallows overlays, move them back out.
  try {
    if (!window.__cookieConsentPinnedGuard) {
      window.__cookieConsentPinnedGuard = true;
      const mo = new MutationObserver(() => {
        ensureCookieOverlaysOnBody();
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    }
  } catch {
    // ignore
  }

  const consent = getCookieConsent();
  if (consent) {
    banner.setAttribute('hidden', 'hidden');
    document.body.classList.add('cookie-consent-resolved');
    return;
  }

  banner.removeAttribute('hidden');
  document.body.classList.remove('cookie-consent-resolved');

  if (banner.dataset.listenerAdded === 'true') return;
  banner.dataset.listenerAdded = 'true';

  const acceptBtn = banner.querySelector('[data-cookie-action="accept"]');
  const rejectBtn = banner.querySelector('[data-cookie-action="reject"]');

  function hide() {
    banner.setAttribute('hidden', 'hidden');
    document.body.classList.add('cookie-consent-resolved');
  }

  if (acceptBtn) {
    acceptBtn.addEventListener('click', () => {
      setCookieConsent('accepted');
      window.dispatchEvent(new CustomEvent('cookieConsentChanged', { detail: { value: 'accepted' } }));
      hide();
    });
  }

  if (rejectBtn) {
    rejectBtn.addEventListener('click', () => {
      setCookieConsent('rejected');
      window.dispatchEvent(new CustomEvent('cookieConsentChanged', { detail: { value: 'rejected' } }));
      hide();
    });
  }
}

export function initCookiesPolicyModal() {
  const modal = document.getElementById('politica-cookies');
  if (!modal || modal.dataset.listenerAdded === 'true') return;

  ensureCookieOverlaysOnBody();
  modal.dataset.listenerAdded = 'true';
  const openTriggers = document.querySelectorAll('[data-cookies-policy-open]');
  const closeElements = modal.querySelectorAll('[data-cookies-policy-close]');
  const closeButton = modal.querySelector('.sorteo-modal__close');
  let lastFocusedElement = null;

  const openModal = () => {
    lastFocusedElement = document.activeElement;
    const panel = modal.querySelector('.sorteo-modal__panel');
    if (panel) panel.scrollTop = 0;
    modal.classList.add('--is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sorteo-modal-open');
    document.body.classList.add('cookies-policy-open');
    closeButton?.focus();
  };

  const closeModal = () => {
    modal.classList.remove('--is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cookies-policy-open');
    if (!document.querySelector('.sorteo-modal.--is-open')) {
      document.body.classList.remove('sorteo-modal-open');
    }
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  };

  openTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      openModal();
    });
  });

  closeElements.forEach((closeEl) => {
    closeEl.addEventListener('click', (event) => {
      event.preventDefault();
      closeModal();
    });
  });

  modal.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
    }
  });
}
